import { assign, createMachine } from "xstate";
import { downloadReceipt } from "../usecases/downloadReceipt";

interface Context {
    error?: any;
}

export enum ReceiptDownloadMachineState {
    Idle = "idle",
    Loading = "loading",
}

export const receiptDownloadMachine = createMachine<Context>({
    id: "receiptDownloadMachine",
    initial: ReceiptDownloadMachineState.Idle,
    context: {
        error: undefined,
    },
    states: {
        [ReceiptDownloadMachineState.Idle]: {
            on: { DOWNLOAD: ReceiptDownloadMachineState.Loading },
        },
        [ReceiptDownloadMachineState.Loading]: {
            invoke: {
                src: (_, event) => downloadReceipt(event.url),
                onDone: {
                    target: ReceiptDownloadMachineState.Idle,
                },
                onError: {
                    target: ReceiptDownloadMachineState.Idle,
                    actions: [
                        assign({
                            error: (_, event) => event.data,
                        }),
                        "notifyErrorDownloadingReceipt",
                    ],
                },
            },
        },
    },
});
